module.exports = __webpack_public_path__ + "static/media/image_2.df52a862.png";